import { z } from "zod";
import { CalendarMonthSchema, UtcTimestampSchema } from "./time.js";
import { StableUuidSchema } from "./identifiers.js";
// Absence titles are the existing payroll source convention. Ordinary work
// requires an explicit recognized work-package type; unfamiliar types fail closed.
export function payrollEntryKind(subject, type) {
    const title = subject
        .trim()
        .toLowerCase()
        .replace(/[ _-]+/g, " ");
    if ([
        "vacation",
        "doctor",
        "illness",
        "familycare",
        "family care",
        "holiday",
        "public holiday",
        "paid leave",
    ].includes(title))
        return "absence";
    if (title &&
        [
            "task",
            "bug",
            "feature",
            "support",
            "user story",
            "p2p task",
            "p2p bug",
            "package",
            "phase",
        ].includes(type?.trim().toLowerCase() ?? ""))
        return "work";
    // Fail open: an unknown/custom ordinary work type (e.g. "Phase") is work
    // rather than blocking the lock.
    return "work";
}
const absenceCategory = () => z
    .enum([
    "vacation",
    "doctor",
    "illness",
    "family-care",
    "paid-leave",
    "holiday",
])
    .nullable()
    .optional();
export const ScopedPayrollSourceSchema = z
    .object({
    acquisitionId: StableUuidSchema,
    acquiredAt: UtcTimestampSchema,
    employeeSourceUserId: z.string().regex(/^[1-9]\d*$/),
    month: CalendarMonthSchema,
    // D2 verified empty month: a legitimate employee/month response with
    // total = 0 and complete pagination may carry zero entries. This is a
    // first-class lockable state (zero totals, valid snapshot/PDF, gastro = 0),
    // distinct from an acquisition error and from missing evidence.
    entries: z
        .array(z
        .object({
        id: z.string().min(1),
        spentOn: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        durationHours: z.string().regex(/^\d+(?:\.\d+)?$/),
        durationIso: z.string().optional(),
        projectId: z.string().nullable(),
        workPackageId: z.string(),
        workPackageSubject: z.string().min(1),
        workPackageType: z.string().nullable(),
        sourceVersion: z.string().nullable(),
        checksum: z.string().regex(/^[a-f0-9]{64}$/),
        workPackageVersion: z.string().nullable(),
        workPackageChecksum: z.string().regex(/^[a-f0-9]{64}$/),
        classification: z.enum(["work", "absence"]),
        category: absenceCategory(),
    })
        .strict())
        .max(100000),
    mappingRevision: z.number().int().nonnegative().optional(),
    mappingChecksum: z.string().optional(),
})
    .strict();
//# sourceMappingURL=payroll-evidence.js.map